import { Flex, Box, Image, Text, Grid } from 'theme-ui'
import React, { useState } from 'react'
import Button from '../shared/Buttons/Button'
import AddToCart from '../product/AddToCartButton'
import { getEncodedShopifyId } from '../../hooks/useShopifyFunctions'
import { Fragment } from 'react'
import useReachCurrency from '../../hooks/useReachCurrency'
import formatPrice, { currencyDef } from '../../utils/formatPrice'
import StyledHeading from '../shared/Typography/Heading/Heading'

const convertSize = size => {
  switch (size) {
    case 'Medium':
      return 'M'
    case 'Small':
      return 'S'
    case 'Large':
      return 'L'
    case 'Extra Large':
      return 'XL'
    default:
      return size
  }
}

const DisplayVariantForSale = ({
  variantList,
  onFinish,
  price,
  compareAtPrice,
  currency,
}) => {
  return (
    <Flex sx={{ width: '100px', flexWrap: 'wrap', justifyContent: 'flex-end' }}>
      {variantList.map((variant, key) => {
        return (
          <Box sx={{ width: '50%' }}>
            <AddToCart
              key={key}
              onFinish={onFinish}
              variant="default"
              title={convertSize(variant.option2)}
              shopifyId={getEncodedShopifyId(variant.id, 'ProductVariant')}
              availabelForSale={true}
              productType={variant.product_type}
              cancelToggleCart={true}
              convertedPrice={price}
              convertedCompareAtPrice={compareAtPrice}
              convertedCurrency={currency || currencyDef}
              sx={{
                fontSize: 0,
                m: '5px',
                p: '6px',
                height: '40px',
                width: '40px',
              }}
            />
          </Box>
        )
      })}
    </Flex>
  )
}

const RebuyLineItem = props => {
  const {
    getRegionalPrice,
    getRegionalCompareAt,
    loaded,
    convertedCurrency,
    notUs,
  } = useReachCurrency(
    props.variants.map(v => ({
      ...v,
      shopifyId: getEncodedShopifyId(v.id, 'ProductVariant'),
    }))
  )
  const [addClicked, setAddClicked] = useState(false)
  const availableVariant = []

  props.variants.map(variant => {
    if (variant.inventory_quantity > 0) {
      availableVariant.push(variant)
    }
  })

  if (props.addedToCart) {
    return <Fragment />
  }

  const regionalPrice = getRegionalPrice(0)
  const regionalCompareAtPrice = getRegionalCompareAt(0)

  const compareAtPrice =
    typeof regionalCompareAtPrice === 'number'
      ? regionalCompareAtPrice
      : availableVariant[0].compareAtPrice

  const price =
    typeof regionalPrice === 'number'
      ? regionalPrice
      : availableVariant[0].price

  return (
    <Flex
      sx={{
        py: '10px',
        pl: '10px',
      }}
    >
      <Flex sx={{ width: ['90px'], flexDirection: 'column' }}>
        <Image src={props.image.src} alt={'no image'} />
      </Flex>

      <Flex
        sx={{
          flexDirection: 'column',
          pl: '8px',
          flex: 1,
          justifyContent: 'center',
        }}
      >
        <StyledHeading as="h6">{props.title}</StyledHeading>

        <Text variant="body2semibold">
          {loaded && formatPrice(Number(price), undefined, convertedCurrency)}
        </Text>
      </Flex>

      <Flex
        sx={{
          justifyContent: 'flex-end',
          alignItems: 'center',
          mr: '10px',
        }}
      >
        {addClicked ? (
          <DisplayVariantForSale
            variantList={availableVariant}
            onFinish={() => props.setAddedToCart(true)}
            compareAtPrice={compareAtPrice > 0 ? compareAtPrice : undefined}
            price={price}
            currency={convertedCurrency}
          />
        ) : availableVariant.length > 1 ? (
          <Button
            variant="default"
            sx={{
              minWidth: '100px',
              height: '35px',
            }}
            onClick={() => setAddClicked(true)}
          >
            ADD
          </Button>
        ) : (
          <AddToCart
            variant="default"
            title={'Add'}
            shopifyId={getEncodedShopifyId(
              availableVariant[0].id,
              'ProductVariant'
            )}
            onFinish={() => props.setAddedToCart(true)}
            availabelForSale={true}
            productType={availableVariant[0].product_type}
            cancelToggleCart={true}
            sx={{
              minWidth: '100px',
              height: '35px',
            }}
          />
        )}
      </Flex>
    </Flex>
  )
}

export default RebuyLineItem
